<template>
    <div>
         <v-card
            class="pa-0"
            outlined
            id="table_border"
        >
            <v-simple-table dense>
                <thead fixed-header>
                    <tr>
                        <th :class="$css_title_module">
                            Observações
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in object" :key="item.id">
                        <td>
                            <span class="pa-2" v-html="item.description"></span>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        object: {
            require: true
        }
    }
}
</script>